import dynamic from 'next/dynamic';
import {
  shouldShowBoxingDayTheme,
  shouldShowChristmasTheme,
  shouldShowCyberWeek,
} from '@/lib/holidays';
import ChristmasHero from './Themes/ChristmasHero';
import BoxingDayHero from './Themes/BoxingDayHero';

const DefaultHero = dynamic(() => import('./Themes/DefaultHero'), {
  ssr: true,
});

const CyberWeekHero = dynamic(() => import('./Themes/CyberWeekHero'), {
  ssr: true,
});

const Main = () => {
  if (shouldShowBoxingDayTheme) {
    return <BoxingDayHero />;
  }

  if (shouldShowChristmasTheme) {
    return <ChristmasHero />;
  }

  if (shouldShowCyberWeek) {
    return <CyberWeekHero />;
  }

  return <DefaultHero />;
};

export default Main;
